import React, {useEffect, useState} from 'react';
import "../style.css";
import {LogoHp} from "@veneer/core";
import {isEmpty} from 'lodash';
import {HashRouter, useLocation} from "react-router-dom";


const HoneyBeeLandingPage = () => {

    const [errorMsg, setErrorMsg] = useState('')
    const [timeOut, setTimeOut] = useState(false)
    const location = useLocation();

    useEffect(() => {
        let query = window.location.search.substring(1);
        let message = query.split("=")[1];
        if (isEmpty(message)) {
            message = window.location.hash.split("=")[1];
        }
        if (message === "Error") {
            setErrorMsg("Access Denied. Please contact your administrator.")
        }
        if (window.location.search.includes("timeout")) {
            setTimeOut(true)
        }
        window.location.hash='#/'
    }, [location])

    return (
        <HashRouter>
            <div className="continer-fluid">
                <div className="row m-r">
                    <div className="col-md-6">
                        <LogoHp appearance="multicolor" size={40}/>
                    </div>
                    <div className="col-md-6">
                        <a href={process.env.REACT_APP_PUBLIC_URL + "/oauth2/authorization/mcsapp"}><p
                            className="sign-in"> Sign in</p></a>
                    </div>
                </div>
            </div>

            {
                timeOut &&
                <section>
                    <div className="center">
                        Session timed out
                    </div>
                </section>
            }

            <section id="banner" className="spsaccount">
                <div className="container">
                    <div className="row">
                        <div className="banner">
                            <h4 className="banner" id="title">HP Supply Encoding Service </h4>
                            <p className="bannerAccessDenied">{errorMsg}</p>
                        </div>
                    </div>
                </div>
            </section>
        </HashRouter>
    )
}

export default HoneyBeeLandingPage;
